module.exports = __webpack_public_path__ + "static/media/ASingleShardBookCover.ce54a146.jpg";